export default __webpack_public_path__ + "static/media/minnesotaVikings@2x.24776489.jpg";